//@flow
import React from 'react';
import { connect } from 'react-redux';

import { trekFilterList } from './helpers';

import {
  filterTrek,
  clearAllFilters,
  addQuery,
  removeQuery,
} from '../../../redux/actions/filterTreksActions';
import { fetchAllTreks } from '../../../redux/actions/trekActions';

import './filter.css';

type obj = {
  min: Number,
  max: Number,
};

type Props = {
  filterData: {
    searchTerm: string,
    days: obj,
    price: obj,
    stars: string,
    month: string,
    isGuided: boolean,
    trekType: string,
    region: string,
  },
  fetchAllTreks: () => void,
  filterTrek: () => void,
  clearAllFilters: () => void,
  addQuery: () => void,
  removeQuery: () => void,
};

const mapStateToProps = ({
  trekFiltersType: { searchTerm, stars, days, price, month, isGuided, trekType, region },
}) => ({
  filterData: {
    searchTerm,
    stars,
    days,
    month,
    price,
    isGuided,
    trekType,
    region,
  },
});

const TrekFilters = ({
  filterTrek,
  clearAllFilters,
  addQuery,
  removeQuery,
  fetchAllTreks,
  filterData,
}: Props) => {
  const handleFilter = async (queryData, query) => {
    let processedData = {
      [query]: queryData,
    };

    if (query === 'trekType') {
      processedData = handleSideEffect(processedData, 'days');
    } else if (query === 'days') {
      processedData = handleSideEffect(processedData, 'trekType');
    }

    addQuery(trekFilterList[query].params(queryData));

    filterTrek(processedData);
    fetchAllTreks();
  };

  const handleSideEffect = (processedData, newQuery) => {
    const defaultValue = trekFilterList[newQuery].compProps.defaultValue || '';

    removeQuery(Object.keys(trekFilterList[newQuery].params(defaultValue)));
    return { ...processedData, [newQuery]: defaultValue };
  };

  const handleReset = (queryData, query) => {
    const processedData = {
      [query]: queryData,
    };
    removeQuery(Object.keys(trekFilterList[query].params(queryData)));
    filterTrek(processedData);
    fetchAllTreks();
  };

  const handleClearAll = () => {
    clearAllFilters();
    fetchAllTreks();
  };

  return (
    <div className="col-xl-2 col-lg-3 col-md-3 col-12 filter-sidebar">
      <div className="widget-wrap">
        <span onClick={handleClearAll} className="clear-filter">
          Clear All Filters
        </span>
        {Object.keys(trekFilterList).map(v => {
          const FilterComp = trekFilterList[v].Component;
          return (
            <FilterComp
              key={FilterComp.toString() + v}
              data={filterData[v]}
              filterFn={innerData => handleFilter(innerData, v)}
              resetFn={innerData => handleReset(innerData, v)}
              {...trekFilterList[v].compProps}
            />
          );
        })}
      </div>
    </div>
  );
};
export default connect(
  mapStateToProps,
  {
    filterTrek,
    clearAllFilters,
    fetchAllTreks,
    addQuery,
    removeQuery,
  }
)(TrekFilters);



// WEBPACK FOOTER //
// ./src/screens/TrekListings/TrekFilters/TrekFilters.jsx